export default "__VITE_ASSET__DzrRq3Lf__"